var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-modal", {
        ref: "modal-edit-report",
        attrs: {
          id: "modal-edit-report",
          "footer-class": "flex-nowrap",
          "no-close-on-backdrop": "",
          "no-close-on-esc": "",
          centered: ""
        },
        scopedSlots: _vm._u([
          {
            key: "modal-header",
            fn: function() {
              return [
                _c("h3", [_vm._v(_vm._s(_vm.$t("modals.editReport.title")))])
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "mt-4 mx-5 mb-3" },
                  [
                    _c("b-form-input", {
                      attrs: {
                        placeholder: _vm.$t("modals.createReport.name"),
                        autofocus: "",
                        debounce: "500"
                      },
                      on: {
                        update: _vm.setName,
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.editReport.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.reportName,
                        callback: function($$v) {
                          _vm.reportName = $$v
                        },
                        expression: "reportName"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "mx-5 mb-4" },
                  [
                    _c("b-form-input", {
                      attrs: {
                        placeholder: _vm.$t("modals.createReport.description"),
                        debounce: "500"
                      },
                      on: {
                        update: _vm.setDescription,
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.editReport.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.reportDescription,
                        callback: function($$v) {
                          _vm.reportDescription = $$v
                        },
                        expression: "reportDescription"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "modal-footer",
            fn: function() {
              return [
                _c(
                  "b-button",
                  {
                    staticClass: "p-3 border-right-light-grey",
                    attrs: { block: "" },
                    on: { click: _vm.cancelModal }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("buttons.cancel")) + " ")]
                ),
                _c(
                  "b-button",
                  {
                    staticClass: "p-3",
                    attrs: {
                      disabled: _vm.isDisabled,
                      variant: "primary",
                      block: ""
                    },
                    on: { click: _vm.editReport }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("modals.editReport.change")) + " "
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }